<template>
  <div class="container">
    <div class="header">
      <div class="logo"><i class="fas fa-box-open"></i></div>
      <h1>爱乐存</h1>
      <p class="subtitle">{{ isManualLogin ? '验证码登录' : '欢迎回来' }}</p>
    </div>

    <div class="content">
      <div class="quick-login" v-if="!isManualLogin">
        <div class="phone-number">
          <i class="fas fa-mobile-alt"></i> {{ maskedPhone }}
        </div>
        <button class="btn-quick-login" @click="quickLogin">
          <i class="fas fa-bolt"></i> 一键登录
        </button>

        <div class="other-login">
          <span class="tip">其他登录方式</span>
          <button class="btn-other" @click="switchToManualLogin">
            <i class="fas fa-sms"></i> 验证码登录
          </button>
        </div>
      </div>

      <div class="manual-login" :class="{ active: isManualLogin }">
        <button class="back-btn" @click="switchToQuickLogin">
          <i class="fas fa-arrow-left"></i> 返回
        </button>

        <div class="form-group">
          <label>手机号码</label>
          <input type="tel" v-model="manualPhone" placeholder="请输入手机号码" maxlength="11">
        </div>

        <div class="form-group">
          <label>验证码</label>
          <div class="verification-code">
            <input type="text" v-model="verificationCode" placeholder="请输入验证码" maxlength="6">
            <button class="btn-get-code" :class="{ active: canGetCode }" :disabled="!canGetCode || countdown > 0" @click="getVerificationCode">
              {{ countdown > 0 ? `${countdown}s后重新获取` : '获取验证码' }}
            </button>
          </div>
        </div>

        <button class="btn-login" @click="manualLogin" :disabled="!canLogin">
          <i class="fas fa-sign-in-alt"></i> 登录
        </button>
      </div>
    </div>

    <div class="footer">
      <p>登录即代表您同意《用户协议》和《隐私政策》</p>
      <p>© 2023 爱乐存 | 智能存储解决方案</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      isManualLogin: false,
      userPhone: '13800138000',
      manualPhone: '',
      verificationCode: '',
      countdown: 0,
      canGetCode: false
    }
  },
  computed: {
    maskedPhone () {
      return this.userPhone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },
    canLogin () {
      return this.manualPhone.length === 11 && this.verificationCode.length === 6
    }
  },
  watch: {
    manualPhone (newVal) {
      this.canGetCode = newVal.length === 11
    }
  },
  methods: {
    quickLogin () {
      alert(`一键登录成功！手机号：${this.userPhone}`)
      this.$router.push('/mine')
    },
    switchToManualLogin () { this.isManualLogin = true },
    switchToQuickLogin () {
      this.isManualLogin = false
      this.manualPhone = ''
      this.verificationCode = ''
    },
    getVerificationCode () {
      if (this.countdown > 0) return
      if (!this.canGetCode) return
      alert(`验证码已发送到手机：${this.manualPhone}`)
      this.countdown = 60
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) clearInterval(timer)
      }, 1000)
    },
    manualLogin () {
      if (!this.canLogin) return
      if (this.verificationCode === '123456') {
        alert(`登录成功！手机号：${this.manualPhone}`)
        this.$router.push('/mine')
      } else {
        alert('验证码错误，请重新输入')
      }
    }
  }
}
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; font-family: 'PingFang SC', sans-serif; }
.container { width: 380px; max-width: 380px; margin: 0 auto 64px; background: #fff; border-radius: 12px; overflow: hidden; border: 1px solid #eee; box-shadow: 0 0 8px rgba(0,0,0,0.05); }
.header { text-align: center; padding: 30px 20px; background: #fff; }
.logo { width: 60px; height: 60px; border-radius: 50%; background: #f0f0f0; margin: 0 auto 15px; display: flex; align-items: center; justify-content: center; font-size: 28px; color: #07c160; }
h1 { font-size: 22px; margin-bottom: 8px; font-weight: 600; color: #333; }
.subtitle { font-size: 14px; color: #888; }
.content { padding: 20px; }
.quick-login { text-align: center; }
.phone-number { font-size: 16px; font-weight: 500; color: #333; margin: 15px 0; }
.btn-quick-login { background: #07c160; color: white; border: none; padding: 14px; border-radius: 8px; font-size: 16px; cursor: pointer; width: 100%; }
.btn-quick-login:active { background: #06ae56; }
.other-login { text-align: center; margin-top: 20px; padding-top: 15px; border-top: 1px solid #f0f0f0; }
.other-login .tip { font-size: 12px; color: #999; margin-bottom: 10px; display: block; }
.btn-other { background: #fff; border: 1px solid #07c160; color: #07c160; padding: 12px; border-radius: 8px; font-size: 14px; cursor: pointer; width: 100%; }
.btn-other:active { background: #f6f6f6; }
.manual-login { display: none; }
.manual-login.active { display: block; }
.form-group { margin-bottom: 16px; text-align: left; }
.form-group label { display: block; margin-bottom: 6px; font-weight: 500; font-size: 14px; color: #555; }
.form-group input { width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 15px; }
.form-group input:focus { border-color: #07c160; outline: none; }
.verification-code { display: flex; gap: 8px; }
.verification-code input { flex: 1; padding: 12px; border-radius: 8px; border: 1px solid #ddd; font-size: 15px; }
.btn-get-code { background: #07c160; color: white; border: none; padding: 12px; border-radius: 8px; font-size: 14px; cursor: pointer; min-width: 110px; }
.btn-get-code:disabled { background: #ccc; }
.btn-login { background: #07c160; color: white; border: none; padding: 14px; border-radius: 8px; font-size: 16px; font-weight: 500; cursor: pointer; width: 100%; margin-top: 10px; }
.btn-login:disabled { background: #ccc; }
.footer { text-align: center; padding: 15px; color: #999; background: #fafafa; font-size: 12px; border-top: 1px solid #f0f0f0; }
</style>
